module.exports = __webpack_public_path__ + "static/media/22ESCWA11.76fd45c7.jpg";